import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '../staff-template/tem.scss';
import { saveCertificateConfig, getCertificateConfig } from 'api/payroll/prove-download';
import { viewUrlFn } from 'api/org/per';
import Upload from '_c/upload';
import staffSearch from '_c/staff-search';
import Preview from './preview';
// 娇艳规则
var rules = function rules($t) {
  return {
    c_id: [{
      required: true,
      message: 'C_ID'
    }],
    // 企业c_id
    c_name_th: [{
      required: true,
      message: $t('1256')
    }],
    // 企业名称（泰）
    staff_formal: [{
      required: true,
      message: $t('221')
    }],
    // 可申请员工各类型，1正式，2非正式
    send_language: [{
      required: true,
      message: $t('221')
    }],
    // 可发送、下载的语言pdf
    date_format: [{
      required: true,
      message: $t('221')
    }],
    // 日期格式，1：佛历年，2：公历年
    sign_staff_id: [{
      required: true,
      message: $t('1256')
    }],
    // 签字人员工ID
    trustee_staff_id: [{
      required: true,
      message: $t('1256')
    }],
    // CEO或受委托人
    mobile: [{
      required: true,
      message: $t('1256')
    }],
    // 联系电话
    email: [{
      required: true,
      message: $t('1256')
    }],
    // 联系邮箱
    sign: [{
      required: true,
      message: $t('313')
    }],
    // 负责人电子签名url地址
    trustee_sign: [{
      required: true,
      message: $t('313')
    }],
    // CEO或受委托人电子签名
    c_sign: [{
      required: true,
      message: $t('313')
    }],
    // 企业签章url地址
    c_mobile: [{
      required: true,
      message: $t('1256')
    }] // 企业电话
    // c_site: [{ required: true, message: $t('1256') }] // 企业地址
  };
};

// 表单字段
var form = function form() {
  return {
    address: '',
    // 企业地址
    trustee_sign: '',
    // CEO或受委托人电子签名
    trustee_staff_id: '',
    // CEO或受委托人
    job: '',
    // 负责人职位
    c_id: '',
    // 企业c_id
    c_name_th: '',
    // 企业名称（泰）
    c_name_en: '',
    // 企业名称（英）
    staff_formal: [],
    // 可申请员工各类型，1正式，2非正式
    send_language: [],
    // 可发送、下载的语言pdf
    c_short_name_th: '',
    // 企业简称（泰）
    c_short_name_en: '',
    // 企业简称（英）
    th_language: '',
    // 泰语标识
    en_language: '',
    // 英语标识
    date_format: '',
    // 日期格式，1：佛历年，2：公历年
    sign_staff_id: '',
    // 签字人员工ID
    mobile: '',
    // 联系电话
    email: '',
    // 联系邮箱
    sign: '',
    // 负责人电子签名url地址
    c_sign: '',
    // 企业签章url地址
    c_mobile: '',
    // 企业电话
    c_site: '',
    // 企业官网
    company_logo: '',
    // 企业logo
    staffName: '' // 负责人名称
  };
};

export default {
  components: {
    Upload: Upload,
    Preview: Preview,
    staffSearch: staffSearch
  },
  data: function data() {
    return {
      subloading: false,
      isEditStaff: false,
      // 选择负责人
      staffInfo: '',
      // 负责人信息
      fileFormat: ['.png', '.jpg', '.jpeg'],
      // 上传限制
      rules: rules(this.$t),
      // 表单校验
      form: form(),
      is_job_ceo_edit: false,
      job_ceo_name: '',
      // CEO或受委托人
      job_ceo: '' // CEO或委托人职位
    };
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      // 获取字段信息
      getCertificateConfig().then(function (res) {
        Object.assign(_this.form, res.data);
        _this.staffChange({
          staff_id: _this.form.sign_staff_id
        });
        _this.update_trustee_staff_id({
          staff_id: _this.form.trustee_staff_id
        });
      });
    },
    /**
     * 图片上传回掉
     * @param { Object } val 上传信息
     * @param { String } bindValue 将要赋值的对象
     */
    uploadSuccess: function uploadSuccess(val, bindValue) {
      var uploadInfo = val[0];
      this.form[bindValue] = uploadInfo ? uploadInfo.object_url : '';
    },
    // 选人
    staffChange: function staffChange(val) {
      var _this2 = this;
      this.form.sign_staff_id = val.staff_id;
      viewUrlFn(val).then(function (res) {
        var _res$data, _res$data2;
        _this2.form.job = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.job_title_name;
        _this2.form.staffName = (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.staff_name;
        _this2.staffInfo = res.data;
        _this2.isEditStaff = false;
      });
    },
    // 更新CEO或受委托人联动CEO或委托人职位
    update_trustee_staff_id: function update_trustee_staff_id(val) {
      var _this3 = this;
      this.form.trustee_staff_id = val.staff_id;
      viewUrlFn(val).then(function (res) {
        var _res$data3, _res$data4, _res$data5, _res$data6;
        // CEO或受委托人  称谓+空格+名+空格+姓
        _this3.job_ceo_name = ((_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.call_type_txt) + ' ' + ((_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.first_name) + ' ' + ((_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.last_name);
        // CEO或委托人职位
        _this3.job_ceo = (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.job_title_name;
        _this3.is_job_ceo_edit = false;
      });
    },
    // 提交
    submitForm: function submitForm() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this4.subloading = true;
          saveCertificateConfig(_this4.form).then(function () {
            _this4.$emit('close');
          }).finally(function () {
            return _this4.subloading = false;
          });
        }
      });
    },
    // 预览
    handlePreview: function handlePreview() {
      var _this5 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this5.$refs.pre.visible = true;
        }
      });
    },
    resetForm: function resetForm() {
      this.form = form();
      this.$refs.form.resetFields();
      this.$emit('close');
    }
  }
};